import { Component } from '@angular/core';

@Component({
  selector: 'app-side-regulamin',
  templateUrl: './side-regulamin.component.html',
  styleUrls: ['./side-regulamin.component.css']
})
export class SideRegulaminComponent {

}
